// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  font-size: 16px;
}

.common-text {
  font-size: 1rem;
  text-indent: 2em;
  text-align: left;
  margin-bottom: 1rem;
}

.text-left {
  text-align: left;
}

.text-indent-2em {
  text-indent: 2em;
}

.gutters-container {
  background-color: transparent;
  margin: 0 5%;
  padding: 2rem 0;
  text-align: left;
  min-height: 100vh;
  position: relative;
  font-family: "Roboto", sans-serif;
}

.gutters-title {
  display: flex;
  width: 100%;
  justify-content: center;
  color: #247a97;
  font-size: 3rem;
  font-weight: 900;
  margin-top: 5rem;
  margin-bottom: 5rem;
  font-style: italic;
  align-items: center;
}

.gutters-container .landing-quote p {
  font-size: 1.75rem;
  text-align: center;
}

.chopDropTitle {
  font-size: 2rem;
  color: #247a97;
  text-align: center;
  margin-top: 2rem;
  margin-bottom: 1rem;
}

.gutters-text .gtext {
  margin-left: 3rem;
  margin-right: 3rem;
  text-indent: 2rem;
  line-height: 1.6;
}

.gutters-logo {
  width: 150px;
  display: block;
  margin: 0 auto;
}

.gutters-images {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 5rem;
  align-items: center;
}

.gutters-image {
  display: grid;
  place-items: center;
  width: 100%;
  max-width: 40vw;
  border-radius: 15px;
  margin-bottom: 1rem;
}

.house-image {
  display: grid;
  place-items: center;
  width: 100%;
  max-width: 80vw;
  border-radius: 15px;
  margin: 1rem 5vw;
}

.gutters-text {
  font-size: 1rem;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: normal;
  font-weight: 400;
}

.bottom-section {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  line-height: 1.5rem;
}

.text-section {
  flex: 1;
}

.image-section {
  flex: 1;
  flex-direction: column;
}

.image-section > .top-image {
  flex: 1;
  width: 100%;
  -o-object-fit: cover;
     object-fit: cover;
  -o-object-position: top;
     object-position: top;
  margin-bottom: 1rem;
  border-radius: 15px;
}

.bottom-images {
  display: flex;
  flex: 1;
  justify-content: space-between;
  width: 90%;
}

.bottom-left-image,
.bottom-right-image {
  flex: 1;
  width: 55%;
  -o-object-fit: cover;
     object-fit: cover;
  border-radius: 15px;
}

.gutter-styles {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 2rem;
}

.gutter-styles ul {
  list-style-type: none;
  padding-left: 0;
  margin: 0;
}

.gutter-styles li {
  font-size: 1rem;
  margin-bottom: 15px;
  color: #247a97;
  text-align: left;
  flex: 0 0 calc(33.33% - 1rem);
  line-height: 1.6;
}

@media screen and (max-width: 770px),
  screen and (max-width: 922px),
  screen and (max-width: 1215px) {
  .gutters-container p,
  .gutters-text p,
  .gutters-text .gtext,
  .chop-drop-text p,
  .text-section p {
    font-size: 1.5rem;
    margin-right: 3vw;
    margin-left: 3vw;
    text-indent: 1rem;
  }

  .gutter-styles li {
    font-size: 1.25rem;
  }

  .text-section {
    padding-right: 0;
  }

  .image-section {
    width: 100%;
  }

  .bottom-images {
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
  }

  .gutters-images {
    flex-direction: row;
    align-items: center;
    width: 100%;
  }

  .gutters-image {
    width: 50%;
    max-width: 50%;
    height: auto;
  }

  .gutters-content {
    flex-direction: column;
  }

  .gutters-text {
    padding-top: 20px;
  }

  .image-section {
    flex-direction: row;
    margin-right: 1rem;
  }

  .image-section > .top-image {
    margin-bottom: 1rem;
  }

  .bottom-images {
    flex-direction: column;
    width: 100%;
    gap: 1rem;
  }

  .bottom-left-image,
  .bottom-right-image {
    width: 100%;
  }
}

@media screen and (min-width: 1216px) {
  .gutters-container p,
  .gutters-text p,
  .gutters-text .gtext,
  .chop-drop-text p,
  .text-section p {
    font-size: 1.25rem;
    margin-right: 5vw;
    margin-left: 5vw;
    text-indent: 2.5rem;
  }

  .gutter-styles li {
    font-size: 1.15rem;
  }

  .gutters-images {
    flex-direction: row;
    justify-content: space-evenly;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/styles/Gutters.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,OAAO;EACP,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,WAAW;EACX,oBAAiB;KAAjB,iBAAiB;EACjB,uBAAoB;KAApB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;;EAEE,OAAO;EACP,UAAU;EACV,oBAAiB;KAAjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;;;EAGE;;;;;IAKE,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,UAAU;IACV,cAAc;IACd,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,SAAS;EACX;;EAEA;;IAEE,WAAW;EACb;AACF;;AAEA;EACE;;;;;IAKE,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,6BAA6B;EAC/B;AACF","sourcesContent":["html {\n  font-size: 16px;\n}\n\n.common-text {\n  font-size: 1rem;\n  text-indent: 2em;\n  text-align: left;\n  margin-bottom: 1rem;\n}\n\n.text-left {\n  text-align: left;\n}\n\n.text-indent-2em {\n  text-indent: 2em;\n}\n\n.gutters-container {\n  background-color: transparent;\n  margin: 0 5%;\n  padding: 2rem 0;\n  text-align: left;\n  min-height: 100vh;\n  position: relative;\n  font-family: \"Roboto\", sans-serif;\n}\n\n.gutters-title {\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  color: #247a97;\n  font-size: 3rem;\n  font-weight: 900;\n  margin-top: 5rem;\n  margin-bottom: 5rem;\n  font-style: italic;\n  align-items: center;\n}\n\n.gutters-container .landing-quote p {\n  font-size: 1.75rem;\n  text-align: center;\n}\n\n.chopDropTitle {\n  font-size: 2rem;\n  color: #247a97;\n  text-align: center;\n  margin-top: 2rem;\n  margin-bottom: 1rem;\n}\n\n.gutters-text .gtext {\n  margin-left: 3rem;\n  margin-right: 3rem;\n  text-indent: 2rem;\n  line-height: 1.6;\n}\n\n.gutters-logo {\n  width: 150px;\n  display: block;\n  margin: 0 auto;\n}\n\n.gutters-images {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 5rem;\n  align-items: center;\n}\n\n.gutters-image {\n  display: grid;\n  place-items: center;\n  width: 100%;\n  max-width: 40vw;\n  border-radius: 15px;\n  margin-bottom: 1rem;\n}\n\n.house-image {\n  display: grid;\n  place-items: center;\n  width: 100%;\n  max-width: 80vw;\n  border-radius: 15px;\n  margin: 1rem 5vw;\n}\n\n.gutters-text {\n  font-size: 1rem;\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: column;\n  justify-content: normal;\n  font-weight: 400;\n}\n\n.bottom-section {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  line-height: 1.5rem;\n}\n\n.text-section {\n  flex: 1;\n}\n\n.image-section {\n  flex: 1;\n  flex-direction: column;\n}\n\n.image-section > .top-image {\n  flex: 1;\n  width: 100%;\n  object-fit: cover;\n  object-position: top;\n  margin-bottom: 1rem;\n  border-radius: 15px;\n}\n\n.bottom-images {\n  display: flex;\n  flex: 1;\n  justify-content: space-between;\n  width: 90%;\n}\n\n.bottom-left-image,\n.bottom-right-image {\n  flex: 1;\n  width: 55%;\n  object-fit: cover;\n  border-radius: 15px;\n}\n\n.gutter-styles {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  flex-wrap: wrap;\n  gap: 2rem;\n}\n\n.gutter-styles ul {\n  list-style-type: none;\n  padding-left: 0;\n  margin: 0;\n}\n\n.gutter-styles li {\n  font-size: 1rem;\n  margin-bottom: 15px;\n  color: #247a97;\n  text-align: left;\n  flex: 0 0 calc(33.33% - 1rem);\n  line-height: 1.6;\n}\n\n@media screen and (max-width: 770px),\n  screen and (max-width: 922px),\n  screen and (max-width: 1215px) {\n  .gutters-container p,\n  .gutters-text p,\n  .gutters-text .gtext,\n  .chop-drop-text p,\n  .text-section p {\n    font-size: 1.5rem;\n    margin-right: 3vw;\n    margin-left: 3vw;\n    text-indent: 1rem;\n  }\n\n  .gutter-styles li {\n    font-size: 1.25rem;\n  }\n\n  .text-section {\n    padding-right: 0;\n  }\n\n  .image-section {\n    width: 100%;\n  }\n\n  .bottom-images {\n    flex-direction: row;\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .gutters-images {\n    flex-direction: row;\n    align-items: center;\n    width: 100%;\n  }\n\n  .gutters-image {\n    width: 50%;\n    max-width: 50%;\n    height: auto;\n  }\n\n  .gutters-content {\n    flex-direction: column;\n  }\n\n  .gutters-text {\n    padding-top: 20px;\n  }\n\n  .image-section {\n    flex-direction: row;\n    margin-right: 1rem;\n  }\n\n  .image-section > .top-image {\n    margin-bottom: 1rem;\n  }\n\n  .bottom-images {\n    flex-direction: column;\n    width: 100%;\n    gap: 1rem;\n  }\n\n  .bottom-left-image,\n  .bottom-right-image {\n    width: 100%;\n  }\n}\n\n@media screen and (min-width: 1216px) {\n  .gutters-container p,\n  .gutters-text p,\n  .gutters-text .gtext,\n  .chop-drop-text p,\n  .text-section p {\n    font-size: 1.25rem;\n    margin-right: 5vw;\n    margin-left: 5vw;\n    text-indent: 2.5rem;\n  }\n\n  .gutter-styles li {\n    font-size: 1.15rem;\n  }\n\n  .gutters-images {\n    flex-direction: row;\n    justify-content: space-evenly;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
